import {Button, Col, Drawer, List, Row, Switch} from "antd";
import {HistoryOutlined} from "@ant-design/icons";
import {useRecoilValue} from "recoil";
import {globalBrandConfigState, globalBrandModuleSettingState, globalWebModuleSettingState,} from "../../../_common/global_state";
import React, {useEffect, useState} from "react";
import VirtualList from "rc-virtual-list";
import useLayoutFunction, {reorderPositions} from "../../function";
import useShared from "../../../_common/_shared";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {useTranslation} from "react-i18next";
import {moduleTranslation} from "../../../_common/function";
import {getSettings} from "../../../router/sidebarRoute";

const EditNavigationModal_3 = (props) => {
    const {isModalOpen, handleCancel} = props;
    const {t} = useTranslation();
    const {saveNavigationFunction, resetNavigationFunction} = useLayoutFunction();
    const {IconCommon, IconModule, checkUserAccessRight} = useShared();

    const [userPreference, setUserPreference] = useState([]);
    const [checkedSwitches, setCheckedSwitches] = useState(userPreference?.map((item) => item?.moduleId?._id));
    const [remainAdding, setRemainAdding] = useState(0);
    const [initialUserPreference, setInitialUserPreference] = useState([]);

    const brandModuleSetting = useRecoilValue(globalBrandModuleSettingState);
    const webModuleSetting = useRecoilValue(globalWebModuleSettingState);
    const brandConfigState = useRecoilValue(globalBrandConfigState);

    const isLocked = (moduleName) => {
        const {accessRightID} = getSettings(moduleName, brandConfigState, brandModuleSetting);
        return accessRightID ? !checkUserAccessRight(accessRightID) : false;
    }

    const handleDragEnd = (result) => {
        if (!result?.destination) {
            return;
        }

        const {source, destination} = result;

        const findObj = userPreference?.find((item) => item?.moduleId?.name === source?.droppableId);
        const desObj = userPreference?.find((item) => item?.moduleId?.name === destination?.droppableId);

        if (desObj?.isLocked || findObj?.isLocked) {
            return false;
        }

        const reorderedItems = reorderPositions(userPreference, findObj?.moduleId?._id, desObj?.position);
        setUserPreference(reorderedItems);
    };

    const isModuleSelected = (id) => {
        return checkedSwitches?.includes(id);
    };

    const isSwitchDisabled = (id) => {
        const currentSwitch = brandModuleSetting?.find((item) => item?._id === id);
        const isSelected = checkedSwitches?.find((checkId) => checkId === id)?.length > 0;

        if (isSelected) {
            return false;
        } else {
            if (userPreference?.length < 5) {
                if (currentSwitch?.parent === null) {
                    return brandModuleSetting?.some((item) => item?.parent?._id === currentSwitch?._id && isModuleSelected(item?._id));
                } else {
                    return isModuleSelected(currentSwitch?.parent?._id);
                }
            } else {
                return true;
            }
        }
    };

    const remove = (id) => {
        setUserPreference((prevUserPreference) =>
            prevUserPreference?.filter((item) => item?.moduleId?._id !== id)
        );
        setCheckedSwitches((prevCheckedSwitches) => {
            return prevCheckedSwitches?.map((item) => {
                if (item === id) {
                    return {_id: item, checked: false};
                }
                return item;
            });
        });
    };

    const add = (add, id) => {
        const itemToAdd = brandModuleSetting.find((item) => item?._id === id);
        if (add && !isModuleSelected(id)) {
            if (userPreference?.length < 5) {
                const newItem = {
                    moduleId: {
                        ...itemToAdd,
                    },
                    position: userPreference?.length + 1,
                    __typename: "UserWebNavigation",
                };

                setUserPreference((prevUserPreference) => [
                    ...prevUserPreference,
                    newItem,
                ]);
                setCheckedSwitches((prevCheckedSwitches) => [
                    ...prevCheckedSwitches,
                    id,
                ]);
            }
        } else if (add === false && isModuleSelected(id)) {
            setUserPreference((prevUserPreference) =>
                prevUserPreference?.filter((item) => item?.moduleId?._id !== id)
            );
            setCheckedSwitches((prevCheckedSwitches) =>
                prevCheckedSwitches?.filter((item) => item !== id)
            );
        }
    };

    const handleSave = async () => {
        await saveNavigationFunction(userPreference);
        handleCancel();
    };

    const handleReset = async () => {
        await resetNavigationFunction();
        handleCancel();
    };

    useEffect(() => {
        const filterModuleSetting = webModuleSetting.filter((item) => item?.moduleId?.isEnabled && !item?.locked && !isLocked(item?.moduleId?.name));
        setUserPreference(filterModuleSetting);
        setInitialUserPreference(filterModuleSetting);
    }, [webModuleSetting]);

    useEffect(() => {
        setCheckedSwitches(userPreference?.map((item) => item?.moduleId?._id));
        const maxAllowedItems = 5;
        const remainModule = maxAllowedItems - userPreference?.length;
        setRemainAdding(remainModule);
        return () => {
            if (!isModalOpen) {
                setUserPreference(initialUserPreference);
            }
        };
    }, [isModalOpen, userPreference]);

    return (
        <Drawer
            size={"large"}
            destroyOnClose
            title={null}
            closeIcon={false}
            open={isModalOpen}
            className={"navigationModal"}
            getContainer={() => document.getElementById("layout-3")}
            footer={[
                <div className={"flex justify-between my-2 mx-4 md:mx-0"}>
                    <div
                        key={"reset"}
                        className={"flex items-center cursor-pointer"}
                        onClick={handleReset}
                    >
                        <HistoryOutlined
                            style={{
                                verticalAlign: "-3px",
                                color: "var(--text-color)",
                                marginRight: "10px",
                            }}
                        />
                        <p className={"hidden md:block"} style={{margin: 0}}>
                            {t("editNavigationModal.resetNavigationToDefault")}
                        </p>
                        <p className={"md:hidden"} style={{margin: 0}}>
                            {t("common.reset")}
                        </p>
                    </div>
                    <div className={"flex items-center cursor-pointer"}>
                        <Button key={"cancel"} onClick={handleCancel}>
                            {t("common.cancel")}
                        </Button>
                        <Button
                            type={"primary"}
                            key={"save"}
                            onClick={handleSave}
                            className={"ms-2"}
                        >
                            {t("common.save")}
                        </Button>
                    </div>
                </div>,
            ]}
            onClose={handleCancel}
        >
            <Row align={"middle"} justify={"space-between"} className={"mt-6 mb-12"}>
                <h1 className={"mb-0"}>{t("common.editNavigation")}</h1>
                <IconCommon
                    onClick={() => handleCancel()}
                    iconName={"cm-cross-regular"}
                    className={"cursor-pointer normal-icon"}
                />
            </Row>
            <div id={"editNavigation"}>
                <Row gutter={[16, 16]}>
                    <Col
                        style={{paddingLeft: "1.15rem", paddingRight: "1.15rem"}}
                        xs={24}
                        md={12}
                    >
                        <div className={"flex justify-between mb-4"}>
                            <p className={"subTitle"}>
                                {t("editNavigationModal.navigationItems")}
                            </p>
                            <p className={"subTitle"}>
                                ( {5 - remainAdding}/5 )
                            </p>
                        </div>
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <div>
                                {userPreference && [...userPreference]
                                    ?.sort((a, b) => a?.position - b?.position)
                                    ?.map((item, index) => {
                                        if (item?.moduleId?.isEnabled) return (
                                            <Droppable
                                                key={item?.moduleId?.name}
                                                droppableId={item?.moduleId?.name}
                                            >
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                    >
                                                        <Draggable
                                                            key={item?.moduleId?.name}
                                                            draggableId={item?.moduleId?.name}
                                                            index={index}
                                                            isDragDisabled={item?.isLocked}
                                                        >
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    className={"editNavigationList"}
                                                                >
                                                                    <div
                                                                        className={"flex *:px-1 justify-start items-center"}>
                                                                        <div className={"!w-2/12 flex-none text-center"}>
                                                                            <IconModule
                                                                                active={false}
                                                                                layout={3}
                                                                                className={"editNavigationIcon"}
                                                                                iconName={`md-${item?.moduleId?.name?.toLowerCase()?.replaceAll(/[-\s.]/g, "")}-regular`}
                                                                            />
                                                                        </div>
                                                                        <div className={"!w-6/12 flex-none text-start"}>
                                                                            <p>
                                                                                {t(moduleTranslation(item?.moduleId?.name))}
                                                                            </p>
                                                                        </div>
                                                                        {!item?.isLocked && (
                                                                            <>
                                                                                <div className={"!w-2/12 flex-none text-end"}>
                                                                                    <IconCommon
                                                                                        iconName={"cm-delete-regular"}
                                                                                        className={"editNavigationIcon cursor-pointer"}
                                                                                        onClick={() => remove(item?.moduleId?._id)}
                                                                                    />
                                                                                </div>
                                                                                <div className={"!w-2/12 flex-none text-end"}>
                                                                                    <div {...provided.dragHandleProps}>
                                                                                        <IconCommon
                                                                                            iconName={"cm-hamburger-regular"}
                                                                                            className={"editNavigationIcon cursor-row-resize"}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        )
                                    })
                                }
                            </div>
                        </DragDropContext>
                    </Col>
                    <Col
                        style={{paddingLeft: "1.15rem", paddingRight: "1.15rem"}}
                        xs={24}
                        md={12}
                    >
                        <p className={"subTitle mb-4"}>
                            {t("editNavigationModal.itemForSelection")}
                        </p>
                        <List>
                            <VirtualList
                                data={brandModuleSetting?.filter((item) => item?.isEnabled && item?.parent === null)}
                                style={{overflowX: "hidden"}}
                                height={"60vh"}
                                itemHeight={47}
                                itemKey={"stock"}
                            >
                                {(item) => {
                                    const isOpen = webModuleSetting?.find((items) => items?.moduleId?.name === item?.name);
                                    const isSelected = checkedSwitches?.find((items) => items === item?._id)?.length > 0;

                                    if (isOpen?.locked || isLocked(item?.name)) return <div key={item?._id}></div>;

                                    let children = [];

                                    brandModuleSetting?.map((items) => {
                                        if (items?.parent?._id === item?._id && items?.isEnabled) {
                                            children?.push(items);
                                        }
                                    });

                                    return (
                                        <>
                                            <div className={"editNavigationList pl-1"}>
                                                <Row gutter={[16, 16]} className={"items-center"}>
                                                    <Col span={4} className={"text-center"}>
                                                        <IconModule
                                                            active={false}
                                                            layout={3}
                                                            className={"editNavigationIcon"}
                                                            iconName={`md-${item?.name?.toLowerCase()?.replaceAll(/[-\s.]/g, "")}-regular`}
                                                        />
                                                    </Col>
                                                    <Col span={16}>
                                                        <p>{t(moduleTranslation(item?.name))}</p>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Switch
                                                            size={"small"}
                                                            defaultChecked={isOpen}
                                                            checked={isSelected}
                                                            onChange={(e) => add(e, item?._id)}
                                                            disabled={isSwitchDisabled(item?._id) || isOpen?.isLocked}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                            {children?.length > 0 && children.map((item) => {
                                                const isSelected = checkedSwitches?.find((items) => items === item?._id)?.length > 0;
                                                const isOpen = webModuleSetting?.find((items) => items?.moduleId?.name === item?.name);

                                                if (isOpen?.locked || isLocked(item?.name)) return <div key={item?._id}></div>;

                                                return (
                                                    <div className={"editNavigationList"}>
                                                        <Row
                                                            gutter={[16, 16]}
                                                            className={"items-center"}
                                                        >
                                                            <Col span={7} push={2} className={"text-end"}>
                                                                <IconModule
                                                                    active={false}
                                                                    layout={3}
                                                                    className={"editNavigationIcon"}
                                                                    iconName={`md-${item?.name?.toLowerCase()?.replaceAll(/[-\s.]/g, "")}-regular`}
                                                                />
                                                            </Col>
                                                            <Col span={13}>
                                                                <p>{t(moduleTranslation(item?.name))}</p>
                                                            </Col>
                                                            <Col span={4}>
                                                                <Switch
                                                                    size={"small"}
                                                                    defaultChecked={isOpen}
                                                                    checked={isSelected}
                                                                    onChange={(e) => add(e, item?._id)}
                                                                    disabled={isSwitchDisabled(item?._id) || isOpen?.isLocked}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                );
                                            })}
                                        </>
                                    );
                                }}
                            </VirtualList>
                        </List>
                    </Col>
                </Row>
            </div>
        </Drawer>
    );
};

export default EditNavigationModal_3;
